import store from '../store/store';
export function wasFolderPrefetched(folderId) {
    return store.prefetchedFolderIds.get(folderId) === true;
}
//# sourceMappingURL=wasFolderPrefetched.js.map